import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/Button/Button'

type MiniPayErrorProps = {
  error: string
  onRetry?: () => void
  showRetry?: boolean
}

export const MiniPayError = memo(function MiniPayError({
  error,
  onRetry,
  showRetry = true,
}: MiniPayErrorProps) {
  const { t } = useTranslation()

  return (
    <div
      className="flex flex-col items-center justify-center px-4 py-8"
      data-testid="container-minipay-error"
    >
      <div className="w-full max-w-md text-center">
        <div className="mb-6">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-red-600 dark:text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3
            className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-2"
            data-testid="text-minipay-error-title"
          >
            {t('miniPay.error.title', { defaultValue: 'Connection Required' })}
          </h3>
          <p
            className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-4"
            data-testid="text-minipay-error-message"
          >
            {error}
          </p>
          <p
            className="text-gray-500 dark:text-gray-500 text-xs"
            data-testid="text-minipay-error-hint"
          >
            {t('miniPay.error.hint', {
              defaultValue:
                'Make sure you are accessing this page from within the MiniPay app.',
            })}
          </p>
        </div>

        {showRetry && onRetry && (
          <Button
            onClick={onRetry}
            className="w-full py-3"
            data-testid="btn-minipay-error-retry"
          >
            {t('miniPay.error.retry', { defaultValue: 'Try Again' })}
          </Button>
        )}
      </div>
    </div>
  )
})
